var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    y: 0.771484,
    width: 40,
    height: 39.9697,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 11.8828C20.9029 11.8828 21.7971 12.0607 22.6312 12.4063C23.4654 12.7519 24.2232 13.2585 24.8613 13.897C25.4993 14.5355 26.0052 15.2935 26.3498 16.1275C26.6945 16.9615 26.8712 17.8553 26.8699 18.7576V26.6616H13.1299V18.7576C13.1286 17.8553 13.3053 16.9615 13.65 16.1275C13.9946 15.2935 14.5005 14.5355 15.1385 13.897C15.7766 13.2585 16.5344 12.7519 17.3685 12.4063C18.2027 12.0607 19.0969 11.8828 19.9999 11.8828V11.8828Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3701 26.6621H28.6301",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.27 26.6621C23.2533 27.0738 23.1553 27.4782 22.9817 27.852C22.8082 28.2257 22.5624 28.5616 22.2585 28.8401C21.9547 29.1187 21.5987 29.3345 21.2111 29.4752C20.8235 29.6158 20.4119 29.6786 20 29.6598C19.588 29.6786 19.1764 29.6158 18.7889 29.4752C18.4013 29.3345 18.0453 29.1187 17.7414 28.8401C17.4376 28.5616 17.1918 28.2257 17.0182 27.852C16.8446 27.4782 16.7467 27.0738 16.73 26.6621",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.78d661e8d0c1bd29674f930341067792.svg";
export { ForwardRef as ReactComponent };